import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { QuestionBase } from '@app/core/models/question/question-base';
import { CheckboxQuestion } from '@app/core/models/question/checkbox-question';
import { detectDevices } from '@app/core/utils';

declare var $;
@Component({
  selector: 'app-kid',
  templateUrl: './kid.component.html'
})
export class KidComponent implements OnInit {
  @Input() numberBoys: number;
  @Input() numberGirls: number;
  @Input() question: QuestionBase<any>;
  @Output() kidChanged = new EventEmitter<Object>();
  getPropertiesName: any;
  isMobileOrTablet: boolean;

  ngOnInit() {
    this.getPropertiesName = Object.keys;
    if (this.numberBoys > 0) {
      this.initKids('kidBoys', this.numberBoys - 1);
    }
    if (this.numberGirls > 0) {
      this.initKids('kidGirls', this.numberGirls - 1);
    }
    this.isMobileOrTablet = detectDevices();
  }

  initKids(kidKey: string, kidIndex: number) {
    if (this.question instanceof CheckboxQuestion) {
      const length = this.question.options[kidKey].length;

      for (let i = 0; i < length; i++) {
        this.question.options[kidKey][i].checked = false;
      }
      for (let i = 0; i <= kidIndex; i++) {
        this.question.options[kidKey][i].checked = true;
      }
    }
  }

  getKids(kidKey: string, kidIndex: number, event?) {
    let allowChecked = false;
    if (this.question instanceof CheckboxQuestion) {
      const length = this.question.options[kidKey].length;
      if (kidIndex === this.question.options[kidKey].length - 1) {
        if (this.question.options[kidKey][kidIndex - 1].checked) {
          allowChecked = false;
        } else {
          allowChecked = true;
        }
      } else {
        if (this.question.options[kidKey][kidIndex + 1].checked) {
          allowChecked = true;
        } else {
          let numOfChecked = 0;
          for (let i = 0; i <= kidIndex; i++) {
            if (this.question.options[kidKey][i].checked) {
              numOfChecked++;
            }
          }
          if (numOfChecked < kidIndex) {
            allowChecked = true;
          } else {
            allowChecked = false;
          }
        }
      }

      if (allowChecked) {
        if (!event.target.checked) {
          event.preventDefault();
        }

        for (let i = 0; i < length; i++) {
          this.question.options[kidKey][i].checked = false;
        }
        for (let i = 0; i <= kidIndex; i++) {
          this.question.options[kidKey][i].checked = true;
        }
      } else {
        this.question.options[kidKey][kidIndex].checked = event.target.checked;
      }

      this.kidChanged.emit(this.question.options);
    }
  }

  onMouseEnter(kidKey: string, kidIndex: number) {
    for (let i = 0; i <= kidIndex; i++) {
      if ($(`#${kidKey}-${i}`).hasClass('inactive')) {
        $(`#${kidKey}-${i}`).removeClass('inactive');
      }
      $(`#${kidKey}-${i}`).addClass('active');
    }
    if (this.question instanceof CheckboxQuestion) {
      for (let i = kidIndex + 1; i < this.question.options[kidKey].length; i++) {
        if ($(`#${kidKey}-${i}`).hasClass('active')) {
          $(`#${kidKey}-${i}`).removeClass('active');
        }
        $(`#${kidKey}-${i}`).addClass('inactive');
      }
    }
  }

  onMouseLeave(kidKey: string) {
    if (this.question instanceof CheckboxQuestion) {
      for (let i = 0; i < this.question.options[kidKey].length; i++) {
        if ($(`#${kidKey}-${i}`).hasClass('active')) {
          $(`#${kidKey}-${i}`).removeClass('active');
        }
        if ($(`#${kidKey}-${i}`).hasClass('inactive')) {
          $(`#${kidKey}-${i}`).removeClass('inactive');
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/kid/kid.component.ts